import { Injectable } from "@angular/core";
import { IID_PRATICA_IRU_CUSTOMER } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDPraticaIruCustomerStore } from "./iidPraticaIruCustomer.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.IID_PRATICA_IRU_CUSTOMER)
export class IIDPraticaIruCustomerQuery extends AbstractInterfaceDataQuery<IID_PRATICA_IRU_CUSTOMER> {

  constructor(protected store: IIDPraticaIruCustomerStore) {
    super(store);
  }
}
